export default "__VITE_ASSET__pWFXlsFU__"